import type { Params } from "../toQueryString";
import { buildPath } from "./buildPath";

const BASE_PATH = "/internal_api/circle_ai/daily_briefs";

export const circleAiDailyBriefs = {
  list: ({ params = {} }: { params?: Params } = {}) =>
    buildPath(BASE_PATH, params),
  today: () => buildPath(`${BASE_PATH}/today`),
  show: (id: string) => buildPath(`${BASE_PATH}/${id}`),
};
